/**
 * withRouter был в react-router-dom v5, а в v6+ его . 
 * Заменяется на хуки (useNavigate, useLocation, useParams) 
 * 
 * Для быстрой миграции используем “обёрточный HOC”.
 * 
 * Использование:
 *  export default withRouter(MyClassComponent);
 * 
 * Внутри класса:
 *  this.props.router.navigate("/home");
 *  const { id } = this.props.router.params;
 * 
 * Замены по полям (v5 → v6)
 *  - this.props.match.params → this.props.params (или this.props.router.params)
 *  - this.props.history.push('/x') → this.props.router.navigate('/x')
 *  - this.props.history.goBack() → this.props.router.navigate(-1)
 *  - this.props.location.pathname → this.props.router.location.pathname
 */
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function withRouter(Component) {
  return function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  };
}

export function withRouterWithHighlight(Component) {
  return function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    const searchParams = new URLSearchParams(location?.search || '');
    // Все значения ?highlight=...
    const highlight = searchParams.getAll('highlight').filter(Boolean);

    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
        highlight={highlight}
      />
    );
  };
}